module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEaADAAQAAAABAAAAEAAAAACz87qxAAAA2klEQVQ4Ec2S0QnCMBCGG+kK7iC6Q6G4hM8dqw997BZFcAelO7hCod5Xc3BJT0FfNNCU3P/ny90lRfG3o23bU9d121cJouGx+sYuothP03T2QMTQZE9vQQmkLMtBDLd5ng85SAFoeKJ3ySEss5msOYRwFXONDBSAxpqmueu2FQQhA43EBLDzAGguBCGCLmxejCGMklVlMyDOSHryDH0+uxBTDiWMfGSUN1uPW0EMQJtYUQb9oLEeKOmJA6i1B++0JBM55Sgp7r1bAMZ1o+GJXq0o/X/z7FPCL1cPVLSyXUwMq58AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/del.png
// module id = stew
// module chunks = 29